import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import ContentWrapper from "./ContentWrapper";
import FastSnackBar from "./FastSnackBar";

const Layout = ({ children, fullWidth }: any) => {
  return (
    <Box>
      <Header />
      <ContentWrapper fullWidth={fullWidth}>
        <FastSnackBar />
        {children}
      </ContentWrapper>
      <Footer />
    </Box>
  );
};

export default Layout;
